module.exports = __webpack_public_path__ + "media/img/pages/companies/melexis-2bbd6e1b307a3b6e45e2cc9d2760e893.png";